<app-content-header [headline]="'customer_add_new_headline' | i18next"></app-content-header>
<div class="row">
  <div class="col">
    <div class="card card-nb">
      <div class="card-body">
          <app-customer-form submitButtonLabel="app_save"
                            [countries]="countries"
                            [showInvoiceMail]="false"
                            [showElectronicInvoiceMail]="false"
                            (formSubmit)="onSubmit($event)"
          ></app-customer-form>
      </div>
    </div>
  </div>
</div>
